import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
  {
    id: 'application',
    title: 'Aplicação',
    type: 'group',
    icon: 'apps',
    children: [
      {
        id: 'dashboard',
        title: 'Início',
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
        exactMatch: true,
      },
      {
        id: 'invoices',
        title: 'Orçamentos',
        type: 'item',
        icon: 'assignment',
        url: '/propostas',
      },
      {
        id: 'clientes',
        title: 'Clientes',
        type: 'item',
        icon: 'group',
        url: '/clientes',
        canShow: 'clients',
      },
      {
        id: 'produtos-e-servicos',
        title: 'Produtos e Serviços',
        type: 'item',
        icon: 'handyman',
        url: '/produtos-e-servicos',
        // badge: {
        //   title: 'Beta',
        //   bg: '#6AD49B',
        //   fg: '#fff',
        // },
      },
      {
        id: 'relatorios',
        title: 'Relatórios',
        type: 'item',
        icon: 'insights',
        url: '/relatorios',
        canShow: 'reports',
        // badge: {
        //   title: 'Beta',
        //   bg: '#6AD49B',
        //   fg: '#fff',
        // },
      },
      {
        id: 'aparencia-da-proposta',
        title: 'Modelos de Orçamento',
        type: 'item',
        icon: 'color_lens',
        url: '/configuracao/modelos',
        canShow: 'settings',
      },
      {
        id: 'indique-e-ganhe',
        title: 'Indique e ganhe',
        type: 'item',
        icon: 'card_giftcard',
        url: '/indique-e-ganhe',
      },
    ],
  },

  {
    id: 'help',
    title: 'Ajuda',
    type: 'group',
    icon: 'help',
    children: [
      {
        id: 'faqs',
        title: 'Perguntas Frequentes',
        url: '/faqs',
        type: 'item',
        icon: 'help',
      },

      {
        id: 'whatsapp-contact',
        title: 'Suporte via Whatsapp',
        type: 'item',
        openInNewTab: true,
        externalUrl: true,
        svg: 'whatsapp',
      },

      {
        id: 'suport-email',
        title: 'Suporte via E-mail',
        type: 'item',
        icon: 'assignment',
      },
      {
        id: 'agendar-apresentação',
        title: 'Agende uma Apresentação',
        type: 'item',
        openInNewTab: true,
        externalUrl: true,
        icon: 'support_agent',
      },
    ],
  },
];
